import React from "react";
import styled from "styled-components";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { TextField } from "@mui/material";
import Button from "@mui/material/Button";

const Wrapper = styled.section`
  color: #230871;
  margin-top: clamp(48px, 8vw, 96px);
  .contact {
    padding: clamp(32px, 6vw, 72px) 5% 0 5%;
    h2 {
      font-weight: 800;
      letter-spacing: -0.02em;
      margin: 0 0 5% 0;
      line-height: 1.05;
      font-size: 40px;
      @media (min-width: 568px) {
        font-size: 46px;
      }
      @media (min-width: 992px) {
        font-size: 58px;
      }
      @media (min-width: 1200px) {
        font-size: 62px;
      }
    }
    .hello-accent {
      color: #87d8d8;
    }
    .send {
      display: block;
      width: 100%;
      margin-top: 24px;
      padding: 22px 16px;
      border-radius: 0;
      background: #230871;
      color: #ffffff;
      letter-spacing: 0.08em;
      font-weight: 600;
    }
    .send:hover {
      background: #230871;
    }
    @media (min-width: 1200px) {
      padding: 5% 10% 5% 10%;
    }
    .contact-inner {
      display: grid;
      gap: 16px;
      align-items: start;
      align-content: start;
      @media (min-width: 768px) {
        grid-template-columns: 1fr 1fr;
        gap: 24px;
        align-items: start;
      }
      @media (min-width: 992px) {
        grid-template-columns: 1fr 1fr 1fr;
        align-items: stretch;
      }
      form {
        display: grid;
        gap: 16px;
        padding-top: 0;
        align-content: start;
        grid-auto-rows: min-content;
        height: 100%;
        .MuiFormControl-root {
          width: 100%;
        }
        .MuiInputBase-root {
          height: 100%;
        }
        input {
          background: #f0f0f0;
          color: #230871;
          border: none;
        }
      }
      form:not(.bottom) {
        grid-auto-rows: 1fr;
      }
      .bottom {
        margin-top: 0%;
        @media (min-width: 768px) {
          min-height: 100%;
        }
        .MuiInputBase-root {
          height: 100%;
        }
        .MuiInputBase-input {
          min-height: 140px;
          max-height: 220px;
          overflow: auto;
        }
      }
      .info {
        background: #f0f0f0;
        padding: 24px;
        margin-top: 0;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        height: 80%;
        @media (min-width: 768px) {
          grid-column: 1 / -1;
        }
        @media (min-width: 992px) {
          grid-column: auto;
        }
        div {
          display: grid;
          gap: 12px;
          margin-top: 0;
        }
        h5 {
          font-weight: 800;
          font-size: 25px;
          margin: 0;
        }
        span {
          font-weight: 700;
        }
      }
    }
  }

  .line {
    border: none;
    background: #230871;
    width: 100%;
    margin-top: 7%;
    height: 1px;
    @media (min-width: 768px) {
      margin-top: 3%;
    }
  }
  .footer-inner {
    padding: 5%;
    display: grid;
    gap: 20%;
    .top {
      .logo {
        display: flex;
        justify-content: flex-start;
        align-self: center;
        gap: 5%;

        h5 {
          /* margin: 3%; */
          font-size: 18px;
        }
        p {
          margin: 0;
          font-size: 13px;
        }
      }
      ul {
        display: grid;
        padding: 0;
        gap: 8%;
        list-style: none;
        li {
          a {
            text-decoration: none;
            color: #230871;
            font-size: 14px;
          }
        }
      }
    }
    .bottom {
      .icons {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5%;
        width: 20%;
      }
    }
    @media (min-width: 568px) {
      padding: 5% 0;
      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .logo {
          width: 30%;
          a {
            width: 80%;
          }
          h5 {
            padding-top: 10%;
          }
          p {
            font-size: 11px;
          }
        }
        ul {
        }
      }
      .bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 1%;
        .icons {
          width: 10%;
        }
      }
    }
    @media (min-width: 768px) {
      padding: 8% 0;

      .top {
        .logo {
          width: 28%;
          gap: 3%;
          a {
            width: 60%;
          }
          h5 {
            padding-top: 10%;
          }
        }
        ul {
          width: 90%;
          display: flex;
          justify-content: flex-end;
          flex-wrap: wrap;
          align-self: center;
          gap: 5%;
        }
      }
    }
    @media (min-width: 992px) {
      padding: 2% 0 0 0;
      .top {
        .logo {
          width: 20%;
        }
      }
      .bottom {
        padding: 0;
        p {
          padding: 0;
        }
        .icons {
          width: 7%;
        }
      }
    }
    @media (min-width: 1200px) {
      .top {
        gap: 20%;
        .logo {
          width: 35%;
          gap: 9%;
          a {
            width: 33%;
          }
          h5 {
            font-size: 30px;
            padding-top: 15%;
            font-weight: 900;
          }
        }
        ul {
          width: 70%;
          display: flex;
          justify-content: flex-end;
          align-self: center;
        }
      }
      .bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0% 0;
        p {
          padding: 0;
        }
      }
    }
  }
`;
function Footer() {
  return (
    <Wrapper id="contact">
      <div className="contact">
        <h2>
          <span>Hello</span>
          <span className="hello-accent">;</span>
          <br />
          Let's Work Together
        </h2>
        <div className="contact-inner">
          <form onSubmit={(e) => e.preventDefault()}>
            <TextField id="filled-basic" label="NAME" variant="filled" />
            <TextField id="filled-basic" label="PHONE" variant="filled" />
            <TextField id="filled-basic" label="EMAIL" variant="filled" />
          </form>
          <form className="bottom" onSubmit={(e) => e.preventDefault()}>
            <TextField
              id="standard-multiline-static message"
              label="MESSAGE"
              multiline
              rows={4}
              variant="filled"
              className="messages"
            />
          </form>
          <div className="info">
            <div>
              <p>LET'S CHAT</p>
              <h5>CONTACT DETAILS</h5>
              <p className="bottom-p">
                Feel free to contact us anytime. We will get back to you as soon
                as we can!
              </p>
              <span>info@jumpstartcommunity.org</span>
            </div>
          </div>
        </div>
        <Button
          variant="contained"
          component="a"
          href="mailto:info@jumpstartcommunity.org?subject=Jump%20Start%20Website%20Enquiry"
          className="send"
        >
          SEND MESSAGE
        </Button>

        <hr className="line"/>
        <div className="footer-inner">
          <div className="top">
            <div className="logo">
              <a href="#home">
                <img src="/images/logo.png" alt="logo" />
              </a>
              <div className="text">
                <h5>Jump Start</h5>
                <p>The mental health movement</p>
              </div>
            </div>
            <ul>
              <li>
                <a href="#about">About Us</a>
              </li>
              <li>
                <a href="#news">Blog & News</a>
              </li>
              <li>
                <a href="#about">For Kids</a>
              </li>
              <li>
                <a href="#about">For Parents</a>
              </li>
              <li>
                <a href="#about">For Schools</a>
              </li>
            </ul>
          </div>
          <div className="bottom">
            <p> jump Start All Right Reserved.</p>
            <div className="icons">
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </a>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

export default Footer;
